/*
 * <aycan-hero-carousel> — sections/aycan-hero-carousel.liquid
 *
 * Ortadaki kart + iki yanda komşu slayt. Gerçek slaytların iki yanına TAM BİR SET
 * kopya eklenir (önce son..ilk, sonra ilk..son). Tek kopya yetmiyordu: son slayttan
 * ilk slaytın kopyasına geçerken onun sağında slayt olmadığı için kenar bir an boş
 * kalıyor, döngü "bitti" gibi görünüyordu. Tam setle her an iki yan da dolu; kopya
 * bir sete varınca geçiş bitince aynı gerçek slayta animasyonsuz atlanır.
 *
 * Konum ÖLÇÜLEREK hesaplanır (hedef slaytın ortası ile görünüm alanının ortası
 * arasındaki fark). Sabit genişlik varsaymıyor; RTL'de flex sırası tersine döndüğü
 * için ölçüm kendiliğinden doğru yönü verir. Sürükleme ve ok tuşları da --dir
 * mantığıyla çevrilir: RTL'de "sonraki" soldan gelir.
 *
 * Metin ve buton yalnız ortadaki kartta görünür (CSS: .is-active). Sınıf geçiş
 * başlarken verilir, metin kart ortaya yaklaşırken gecikmeli belirir.
 */
(() => {
  if (customElements.get('aycan-hero-carousel')) return;

  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class AycanHeroCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.aycan-hc__viewport');
      this.track = this.querySelector('.aycan-hc__track');
      this.real = [...this.track.querySelectorAll(':scope > .aycan-hc__slide')];
      this.dots = [...this.querySelectorAll('.aycan-hc__dot')];
      this.toggle = this.querySelector('.aycan-hc__toggle');
      this.count = this.real.length;
      if (this.count < 2) return;

      this.rtl = getComputedStyle(this).direction === 'rtl';
      this.offset = 0;

      // Kopyalar ekran okuyucudan ve sekme sırasından çıkar ama TIKLANABİLİR kalır:
      // `inert` yandaki kopya karta tıklamayı da yutuyordu, son slayttan sonra döngü
      // kopyaya geçemiyor, "bitiyordu".
      const clone = (el) => {
        const c = el.cloneNode(true);
        c.classList.remove('is-active');
        c.setAttribute('aria-hidden', 'true');
        c.dataset.hcClone = '';
        c.querySelectorAll('a, button').forEach((n) => n.setAttribute('tabindex', '-1'));
        c.removeAttribute('id');
        c.querySelectorAll('[id]').forEach((n) => n.removeAttribute('id'));
        c.querySelectorAll('img').forEach((img) => {
          img.setAttribute('loading', 'lazy');
          img.removeAttribute('fetchpriority');
        });
        return c;
      };
      this.track.prepend(...this.real.map(clone));
      this.track.append(...this.real.map(clone));
      this.slides = [...this.track.querySelectorAll(':scope > .aycan-hc__slide')];
      this.index = this.count;

      this.onTransitionEnd = this.onTransitionEnd.bind(this);
      this.track.addEventListener('transitionend', this.onTransitionEnd);

      this.dots.forEach((dot, k) => dot.addEventListener('click', () => this.go(this.count + k)));

      // Yandaki (etkin olmayan) slayta tıklamak onu öne getirir; bağlantısına gitmez.
      this.slides.forEach((slide, i) => {
        slide.addEventListener('click', (e) => {
          if (this.dragged) { e.preventDefault(); return; }
          if (i !== this.index) { e.preventDefault(); this.go(i); this.restart(); }
        });
      });

      this.setAttribute('tabindex', '-1');
      this.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const forward = (e.key === 'ArrowRight') !== this.rtl;
        this.go(this.index + (forward ? 1 : -1));
        this.restart();
      });

      this.bindDrag();
      this.bindAutoplay();

      this.resizeObserver = new ResizeObserver(() => this.go(this.index, false));
      this.resizeObserver.observe(this.viewport);
      this.go(this.index, false);
      // İlk kartın metni gecikmesiz görünür; geçiş animasyonları ilk boyamadan sonra açılır.
      requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-ready')));
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      clearInterval(this.timer);
    }

    // Hedef slaytı görünüm alanının ortasına getiren öteleme.
    targetOffset(i) {
      const vp = this.viewport.getBoundingClientRect();
      const sl = this.slides[i].getBoundingClientRect();
      return this.offset + (vp.left + vp.width / 2) - (sl.left + sl.width / 2);
    }

    apply(offset, animate) {
      this.offset = offset;
      this.track.style.transition = animate && !reduceMotion() ? '' : 'none';
      this.track.style.transform = `translate3d(${offset}px, 0, 0)`;
      if (!animate) void this.track.offsetWidth; // geçişsiz atlamayı hemen uygula
    }

    go(i, animate = true) {
      const target = this.targetOffset(i);
      this.index = i;
      this.apply(target, animate);
      this.paint();
      if (!animate || reduceMotion()) this.settle();
    }

    onTransitionEnd(e) {
      if (e.target !== this.track || e.propertyName !== 'transform') return;
      this.settle();
    }

    // Kopya setlerden birindeysek ortadaki gerçek sette aynı slayta animasyonsuz atla.
    settle() {
      if (this.index < this.count) this.go(this.index + this.count, false);
      else if (this.index >= this.count * 2) this.go(this.index - this.count, false);
    }

    // 0 tabanlı gerçek slayt sırası.
    realIndex() {
      return ((this.index % this.count) + this.count) % this.count;
    }

    paint() {
      const r = this.realIndex();
      this.slides.forEach((s, i) => {
        // Aynı slaytın üç kopyası birlikte etkin sayılır: kopyadan gerçeğe atlanınca
        // metin yeniden gizlenip belirmez.
        const on = i % this.count === r;
        s.classList.toggle('is-active', on);
        if ('hcClone' in s.dataset) return;
        // Ekran dışındaki gerçek slaytların bağlantıları sekme sırasından çıkar.
        s.setAttribute('aria-hidden', String(!on));
        s.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', on ? '0' : '-1'));
      });
      this.dots.forEach((d, k) => {
        const on = k === r;
        d.classList.toggle('is-on', on);
        if (on) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }

    bindDrag() {
      let x0 = null;
      let start = 0;
      this.dragged = false;
      this.viewport.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        x0 = e.clientX;
        start = this.offset;
        this.dragged = false;
      });
      this.viewport.addEventListener('pointermove', (e) => {
        if (x0 === null) return;
        const dx = e.clientX - x0;
        if (!this.dragged && Math.abs(dx) < 8) return;
        this.dragged = true;
        this.apply(start + dx, false);
      });
      const end = (e) => {
        if (x0 === null) return;
        const dx = e.clientX - x0;
        x0 = null;
        if (!this.dragged) return;
        const width = this.slides[this.index].getBoundingClientRect().width;
        let step = 0;
        if (Math.abs(dx) > width * 0.12) step = (dx < 0) !== this.rtl ? 1 : -1;
        this.go(this.index + step);
        this.restart();
        // Tıklama olayı sürüklemeden hemen sonra gelir; bir karelik bekleme onu yutar.
        requestAnimationFrame(() => { this.dragged = false; });
      };
      this.viewport.addEventListener('pointerup', end);
      this.viewport.addEventListener('pointercancel', end);
      this.viewport.addEventListener('pointerleave', end);
    }

    /*
     * Otomatik geçiş: fare üstündeyken ya da odak içerideyken durur, sekme görünmezken
     * ilerlemez. Hareket azaltmayı seçen ziyaretçide hiç başlamaz. Durdur/oynat düğmesi
     * (WCAG 2.2.2) kalıcı durdurur; ziyaretçi elle geçince sayaç baştan başlar.
     */
    bindAutoplay() {
      if (this.dataset.autoplay !== 'true' || reduceMotion()) {
        if (this.toggle) this.toggle.hidden = true;
        return;
      }
      this.ms = parseInt(this.dataset.interval, 10) || 7000;
      this.hover = false;
      this.stopped = false;
      this.addEventListener('pointerenter', () => { this.hover = true; });
      this.addEventListener('pointerleave', () => { this.hover = false; });
      this.addEventListener('focusin', () => { this.hover = true; });
      this.addEventListener('focusout', () => { this.hover = false; });
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.restart()));
      this.toggle?.addEventListener('click', () => {
        this.stopped = !this.stopped;
        this.toggle.setAttribute('aria-pressed', String(this.stopped));
        this.toggle.setAttribute('aria-label', this.stopped ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause);
        this.toggle.classList.toggle('is-stopped', this.stopped);
      });
      this.restart();
    }

    restart() {
      if (!this.ms) return;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (!this.hover && !this.stopped && !document.hidden) this.go(this.index + 1);
      }, this.ms);
    }
  }

  customElements.define('aycan-hero-carousel', AycanHeroCarousel);
})();
